import { MigrationSpec } from "../migration.models"

/** A copy of qpien-ai's `V1_LAYER_PROMPT_NAMES` — the probe has to select what the runner moves. */
const V1_LAYER_PROMPT_NAMES = [
  "ACTION_DETECTION",
  "ANALYSIS_CONTENT",
  "ANALYSIS_CONTENT_CALL",
  "ANALYSIS_CONTENT_CHAT",
  "ANALYSIS_CONTENT_COMMENT_QUESTION",
  "ANALYSIS_CONTENT_QUERY",
  "ANALYSIS_CONTENT_TICKET",
  "ANSWER_BY_ACTION_CHAT",
  "ANSWER_BY_ACTION_COMMENT",
  "ANSWER_BY_ACTION_PRIVATE_REPLY",
  "ANSWER_BY_INSTRUCTION",
  "ANSWER_BY_MARKETPLACE_LISTING",
  "ANSWER_BY_RAG_CHAT",
  "ANSWER_BY_RAG_COMMENT",
  "ANSWER_BY_RAG_PRIVATE_REPLY",
  "ANSWER_BY_RAG_QUESTION",
  "ANSWER_QUESTION",
  "ASSISTANT_CONTEXTUAL_SUGGESTION",
  "ASSISTANT_KNOWLEDGE_RELEVANCE",
  "BARCODE_TO_TEXT",
  "CHANGELOG_TRANSLATION",
  "CLOSE_CONVERSATION",
  "CLOSING_NOTE",
  "COMMERCE_AGENT_TOOL_DESCRIPTIONS",
  "COMMERCE_CONTINUATION_CLASSIFIER",
  "COMMERCE_GUIDANCE_ENFORCEMENT",
  "COMMERCE_PRODUCT_RERANK",
  "COMMERCE_QUERY_PLANNER",
  "COMMERCE_SLOT_EXTRACTOR",
  "ENRICH_QUERY_MACRO",
  "ENRICH_USER_QUERY",
  "ENRICH_USER_QUERY_IMAGE",
  "ENRICH_USER_QUERY_TEXT",
  "EXPAND",
  "FINALIZE_AI_CONTENT",
  "FIRST_PROCESS_PHONE",
  "FIX_SPELLING",
  "FLOW_AI_RESPONSE_VALUE",
  "GENERATE_ANSWER_FROM_KNOWLEDGE_MACRO",
  "GET_PRODUCT_ID_PROMPT",
  "IMAGE_TO_TEXT_PROMPT",
  "INBOX_TRANSLATION",
  "INTENT_DETECTION_AI_ASSISTANT",
  "INTENT_DETECTION_CHAT",
  "INTENT_DETECTION_COMMENT",
  "INTENT_DETECTION_PRIVATE_REPLY",
  "INTENT_DETECTION_QUESTION",
  "MAKE_FORMAL",
  "MAKE_FRIENDLY",
  "NORMALIZE_TURKISH_CHARACTER",
  "RERANK_CHUNKS_MACRO",
  "SKILL_AGENT_DECISION",
  "SKILL_TRIGGER_DECISION",
  "SKILL_TURN_ROUTE",
  "SUMMARIZE_CONVERSATION_BY_AI",
  "TRANSLATE",
  "WRITE_RESPONSE_PROMPT"
]

const aiPromptV1Layer: MigrationSpec = {
  type: "MIGRATE_AI_PROMPT_V1_LAYER",
  collection: "AiPrompts",
  risk: "SAFE",
  title: {
    en: "AI prompts → v1-only prompts onto the v1 layer",
    tr: "AI promptları → yalnızca v1'in okuduğu promptlar v1 katmanına"
  },
  description: {
    en:
      "Relabels the BASE rows (`engineVersion: null`) of every prompt only engine v1 reads to " +
      '`engineVersion: "v1"`, every role row of a name together. BASE is left with the ' +
      "prompts several engines read, v2's own rows stay on v2.",
    tr:
      "Yalnızca v1 motorunun okuduğu promptların BASE satırlarını (`engineVersion: null`) " +
      '`engineVersion: "v1"` olarak yeniden etiketler; bir ismin tüm rol satırları birlikte ' +
      "taşınır. BASE'de birden çok motorun okuduğu promptlar kalır, v2'nin kendi satırları v2'de kalır."
  },
  affectedFilter: { name: { $in: V1_LAYER_PROMPT_NAMES }, engineVersion: null },
  sampleFields: ["name", "role", "engineVersion", "usage"],
  preview: (doc) => ({ ...doc, engineVersion: "v1" }),
  notes: [
    {
      en:
        "Behaviour does not change: v1 reads its own layer first and BASE otherwise, so it " +
        "reads the same text before and after. The row is updated in place and keeps its " +
        "version history.",
      tr:
        "Davranış değişmez: v1 önce kendi katmanını, yoksa BASE'i okur; öncesinde ve sonrasında " +
        "aynı metni okur. Satır yerinde güncellenir, versiyon geçmişi korunur."
    },
    {
      en:
        "A name that already has an identical v1 copy (an unedited fork) loses the copy and its " +
        "BASE row moves instead. A v1 copy with different text is left untouched and listed under " +
        "`conflicts` in the run result; that name stays pending until one of the two is deleted.",
      tr:
        "Birebir aynı v1 kopyası olan (düzenlenmemiş fork) bir isimde kopya silinir, yerine BASE " +
        "satırı taşınır. Metni farklı bir v1 kopyası varsa iki satıra da dokunulmaz, çalıştırma " +
        "sonucunda `conflicts` altında listelenir; ikisinden biri silinene kadar o isim bekler."
    },
    {
      en:
        "Needs the qpien-ai build that knows `migrateAiPromptV1Layer`, and must run after " +
        "MIGRATE_AI_PROMPT_ENGINE_VERSIONS. After it, a newer engine that starts reading one of " +
        "these prompts has to fork it from v1 — it no longer falls back to BASE.",
      tr:
        "`migrateAiPromptV1Layer` operasyonunu içeren qpien-ai sürümü gerekir ve " +
        "MIGRATE_AI_PROMPT_ENGINE_VERSIONS'tan sonra çalışmalıdır. Sonrasında bu promptlardan " +
        "birini okumaya başlayan yeni bir motor onu v1'den fork etmelidir — artık BASE'e düşmez."
    }
  ]
}

export default aiPromptV1Layer
